module.exports = __webpack_public_path__ + "img/42.142e55f9.png";